import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0524',
    ecrans: ['00-2']
});
